import JwtService from "@/utils/jwt.service";

export default {
    errors: null,
    user: {},
    billings: [],
    billingsCount: 0,
    isLoading: true,
    isAuthenticated: !!JwtService.getToken(),
    isAdmin: false,
    accessLevel: 0,
    message: [],
    loading: false
}